import { type FC } from 'react';
import { Select, Space, Flex } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Text } from '@g2u/ui-kit';

import { ServiceAreaType } from 'types';
import styles from './technician-service-area-controls.module.scss';

const RADIUS_OPTIONS_KM = [5, 10, 15, 20, 25, 30];

type Props = Readonly<{
  areaType: ServiceAreaType;
  onAreaTypeChange: (areaType: ServiceAreaType) => void;
  radius: number;
  onRadiusChange: (radius: number) => void;
  onSearch: () => void;
  isSearching?: boolean;
  isAdmin: boolean;
}>;

export const TechnicianServiceAreaControls: FC<Props> = ({
  areaType,
  onAreaTypeChange,
  radius,
  onRadiusChange,
  onSearch,
  isSearching,
  isAdmin,
}) => (
  <Flex vertical gap={4} className={styles.controls}>
    <Space.Compact block>
      <Select
        value={areaType}
        onChange={(value) => onAreaTypeChange(value)}
        className={styles.controls__areaType}
        options={[
          { value: ServiceAreaType.Primary, label: 'Primary Area' },
          { value: ServiceAreaType.Secondary, label: 'Secondary Area', disabled: !isAdmin },
        ]}
      />
      <Select
        value={radius}
        onChange={(value) => onRadiusChange(value)}
        className={styles.controls__radius}
        options={RADIUS_OPTIONS_KM.map((km) => ({ value: km, label: `${km} km` }))}
      />
      <Button.$
        type={Button.Type.Primary}
        icon={<SearchOutlined />}
        onClick={onSearch}
        loading={isSearching}
        dataTestId="search-service-area-suburbs-button"
      />
    </Space.Compact>
    <Text.$ italic type="secondary">
      *The km radius here is NOT based on the actual travel distance but on &quot;as the crow flies&quot;—a circle of
      all suburbs within that area.*
    </Text.$>
  </Flex>
);
